import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import { Alert, Button, Card, Collapse, Form, Input, Typography } from 'antd';
import { useState } from 'react';
import { useLogin } from '../api/auth';
import { devToken } from '../api/client';
import { BrandMark } from '../components/Brand';

interface Values {
  email: string;
  password: string;
}

/** Trang đăng nhập. Khung trái navy mang thương hiệu, form bên phải. */
export function LoginPage() {
  const login = useLogin();
  const qc = useQueryClient();
  const [dev, setDev] = useState('');

  return (
    <div className="login-page">
      <div className="login-brand">
        <div className="brand" style={{ fontSize: 22 }}>
          <BrandMark size={34} />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
            <span>SERIEVO</span>
            <small style={{ fontSize: 12 }}>ECOM ACCOUNTING</small>
          </div>
        </div>
        <Typography.Paragraph style={{ color: '#C3CAD3', marginTop: 24, maxWidth: 360 }}>
          Đối soát đơn hàng, hóa đơn, phí sàn và tiền về của shop Shopee, TikTok Shop; ra số liệu thuế có chứng từ gốc.
        </Typography.Paragraph>
      </div>

      <Card className="login-card" title="Đăng nhập" variant="borderless">
        {login.error && (
          <Alert type="error" showIcon style={{ marginBottom: 16 }} message={login.error.message} role="alert" />
        )}
        <Form<Values>
          layout="vertical"
          requiredMark={false}
          onFinish={(v) => login.mutate({ email: v.email, password: v.password })}
          disabled={login.isPending}
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Nhập email' },
              { type: 'email', message: 'Email không hợp lệ' },
            ]}
          >
            <Input prefix={<MailOutlined />} autoComplete="username" inputMode="email" autoFocus size="large" />
          </Form.Item>
          <Form.Item label="Mật khẩu" name="password" rules={[{ required: true, message: 'Nhập mật khẩu' }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" size="large" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block size="large" loading={login.isPending}>
            Đăng nhập
          </Button>
        </Form>
        <Typography.Paragraph type="secondary" style={{ marginTop: 16, marginBottom: 0, fontSize: 12 }}>
          Quên mật khẩu hoặc cần tài khoản: liên hệ quản trị SeriEvo của công ty bạn.
        </Typography.Paragraph>

        {import.meta.env.DEV && (
          <Collapse
            ghost
            size="small"
            style={{ marginTop: 8 }}
            items={[
              {
                key: 'dev',
                label: 'Token dev (chỉ khi chạy vite ở máy dev)',
                children: (
                  <>
                    <Input.TextArea
                      aria-label="Token dev"
                      rows={3}
                      value={dev}
                      onChange={(e) => setDev(e.target.value)}
                      placeholder="npm run token:dev -- --tenants 1"
                    />
                    <Button
                      style={{ marginTop: 8 }}
                      disabled={!dev.trim()}
                      onClick={() => {
                        devToken.set(dev.trim());
                        void qc.invalidateQueries();
                      }}
                    >
                      Dùng token dev
                    </Button>
                  </>
                ),
              },
            ]}
          />
        )}
      </Card>
    </div>
  );
}
